import { useEffect, useState } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ErrorState, Loading } from "@/components/States";

export default function InvitationPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { principal, acceptInvitation } = useAuth();
  const [invitation, setInvitation] = useState(null);
  const [form, setForm] = useState({ full_name: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get(`/auth/invitations/${token}`)
      .then(({ data }) => setInvitation(data))
      .catch((err) => setError(apiError(err, "La invitacion no esta disponible.")));
  }, [token]);

  if (principal) return <Navigate to={principal.kind === "parent" ? "/p" : "/"} replace />;

  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      await acceptInvitation(token, form);
      navigate("/p", { replace: true });
    } catch (err) {
      setError(apiError(err, "No pudimos aceptar la invitacion."));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="grid min-h-screen place-items-center bg-slate-50 px-4 py-10">
      <div className="w-full max-w-md">
        {error && !invitation ? <ErrorState message={error} /> : !invitation ? <Loading label="Revisando invitacion..." /> : (
          <form onSubmit={submit} className="estudia-card space-y-5 p-6" data-testid="invitation-accept-form">
            <div>
              <span className="grid h-12 w-12 place-items-center rounded-2xl bg-blue-600 font-display font-bold text-white">eI</span>
              <h1 className="mt-4 font-display text-2xl font-extrabold text-slate-900">Únete a {invitation.family_name}</h1>
              <p className="mt-1 text-sm text-slate-500">Crearás una cuenta de tutor para {invitation.email}.</p>
            </div>
            <div>
              <Label htmlFor="invite-name">Nombre completo</Label>
              <Input id="invite-name" required minLength={2} maxLength={160} value={form.full_name}
                onChange={(event) => setForm({ ...form, full_name: event.target.value })} className="estudia-touch mt-1.5" />
            </div>
            <div>
              <Label htmlFor="invite-password">Contraseña</Label>
              <Input id="invite-password" type="password" required minLength={8} maxLength={128} value={form.password}
                onChange={(event) => setForm({ ...form, password: event.target.value })} className="estudia-touch mt-1.5" />
            </div>
            {error && <p className="rounded-xl bg-rose-50 px-3 py-2 text-sm text-rose-700">{error}</p>}
            <Button type="submit" disabled={busy} className="estudia-touch w-full rounded-xl bg-blue-600 font-bold hover:bg-blue-700">
              {busy ? "Creando cuenta..." : "Aceptar invitacion"}
            </Button>
          </form>
        )}
      </div>
    </main>
  );
}
